import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  activeTab: 0
};

export const activeTabDocument360Reducer = (state = initialState, action) => {
  switch (action.type) {
      case "ACTIVE_TAB_FOR_DOCUMENT360":
      return {
        ...state,
        activeTab: action.payload
      };
    default:
      return state;
  }

};
